<template>
  <div class="wrap">
    <h1>安心クラウドバックアップ利用規約</h1>
    <p>
      「安心クラウドバックアップ利用規約」は、株式会社ルクレ（以下「ルクレ」といいます）が運営する、「安心クラウドバックアップ」サービス（以下「本サービス」）に関し、お客様（以下、「ユーザ」といいます）の利用に関する決まりを定めるものです。本サービスを利用することにより、ユーザは本規約の内容に同意したものとみなします。
    </p>
    <br />
    <h2>第1条 （定義）</h2>
    <p>
      本規約において用いられる用語は、次の各号のとおりに定義します。
    </p>
    <ol>
      <li>(1)「本サービス」とは、「安心クラウドバックアップ」の名称のもと行われる、ルクレが提供する工事写真台帳作成ソフトウェア「蔵衛門御用達2020シリーズ」と連携した、工事写真台帳バックアップサービスとその関連する一切のサービスの提供をいいます。</li>
      <li>(2)「ユーザ」とは、本サービスの利用者をいいます。</li>
      <li>(3)「コンテンツ」とは、本サービスにおいてユーザにより送信、複製、その他の方法により使用される、すべてのテキスト、写真、その他の素材をいいます。</li>
      <li>(4)「工事」とは、ユーザが工事写真台帳を作成する対象となる案件の単位をいいます。</li>
    </ol>
    <br />
    <h2>第2条 （規約の変更）</h2>
    <ol>
      <li>1. 本規約は、本サービスにおけるルクレとユーザとの一切の関係に適用します。</li>
      <li>
        2. ルクレは、以下の場合において、ユーザの同意を得ることなく本規約およびその他の告知（以下「本規約等」といいます。）の内容を変更できるものとし、当該変更がなされた場合、従前の本規約等は無効となり、最新の本規約等が適用されるものとします。
        <ol>
          <li>(1) 本規約等の内容の変更が、ユーザの一般の利益に適合するとき。</li>
          <li>(2) 本規約等の内容の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき。</li>
        </ol>
      </li>
      <li>3. ルクレは、前項による本規約等の内容の変更にあたり、変更後の本規約等の効力発生日の１か月前までに、本規約等を変更する旨及び変更後の本規約等とその効力発生日を当社ウェブサイト（URL：https://www.kuraemon.com/配下）に掲示し、またはユーザに電子メールで通知します。</li>
    </ol>
    <br />
    <h2>第3条 （本サービスの追加または変更）</h2>
    <p>ルクレは本サービスについて、必要に応じサービスの追加または変更をすることができるものとします。その場合、ルクレはユーザに対し、その旨をルクレのサイトに掲載する等しかるべき方法で通知するものとします。</p>
    <br />
    <h2>第4条 （利用料金の支払いおよび利用期間）</h2>
    <ol>
      <li>1. ユーザは、本サービスを利用するにあたって、別途定める規約にしたがって利用期間・保管容量に応じた対価を支払うものとします。なお、利用料金および支払方法の定めは随時改訂され得るものであり、ユーザは、本サービス利用時点でその都度有効な利用料金および支払い方法に従うこととします。</li>
      <li>2. 利用期間の満了によって、ユーザがアップロードしたコンテンツは削除され、ルクレサーバーには保存されません。また、一度削除されたコンテンツは元に戻すことができません。</li>
    </ol>
    <br />
    <h2>第5条 （本サービスの中断等）</h2>
    <ol>
      <li>
        1. ルクレは、次の各号のいずれかに該当する場合には、ユーザへ事前に通知することなく、一時的に本サービスを中断する場合があります。
        <ol>
          <li>(1) 本サービスのシステムの保守、点検、修理もしくは変更を定期的又は緊急に行う場合</li>
          <li>(2) 火災、停電等により本サービスの提供ができなくなった場合</li>
          <li>(3) 地震、噴火、洪水または津波等の天災により本サービスの提供ができなくなった場合</li>
          <li>(4) 戦争、騒乱、変乱、暴動または労働争議等により本サービスの提供ができなくなった場合</li>
          <li>(5) その他、運用上または技術上、ルクレが本サービスの一時的な中断を要すると判断した場合</li>
        </ol>
      </li>
      <li>2. ルクレは、善良な管理者の注意義務をもって本サービスを提供するものとしますが、不慮のシステムのトラブル等によりデータを失うことや、ソフトウェアに予期せぬ不具合や障害が発生すること等があります。ルクレはこれらの場合において発生したあらゆる損失、損害に対する責任を負わないものとします。</li>
    </ol>
    <br />
    <h2>第6条 （本サービスの提供地域）</h2>
    <p>本サービスは日本国内のユーザへの提供を目的に運営・管理されています。日本国外において本サービスを使用することはできません。</p>
    <br />
    <h2>第7条 （工事IDの管理責任）</h2>
    <ol>
      <li>1. ルクレはユーザが作成した工事に対して「工事ID」を付与します。</li>
      <li>2. ユーザは、本規約に基づき付与された「工事ID」を自己の責任において管理、使用をするものとします。</li>
      <li>3. 前項の規定にもかかわらず、ユーザの管理不備、使用上の過誤等により、ユーザおよびその他の者が損害を被った場合、ルクレは一切の責任を負わないものとします。</li>
    </ol>
    <br />
    <h2>第8条  （個人情報）</h2>
    <p>ルクレがお預かりする個人情報は、別途ルクレが定める個人情報保護方針に従って取り扱われます。</p>
    <br />
    <br />
    <h2>第9条  （禁止事項）</h2>
    <ol>
      <li>
        1. 本規約に特に定めるほか、本サービスにおいてユーザは次の各号のいずれかに該当する行為または該当するおそれのある行為をおこなってはなりません。
        <ol>
          <li>(1) 本サービスを第三者へ販売するまたは有償で提供するなどの行為</li>
          <li>(2) サーバーに負担をかける行為、および他のユーザのアクセスまたは操作を妨害する行為</li>
          <li>(3) その他公序良俗、一般常識に反する行為</li>
          <li>(4) 上記に準ずる行為</li>
        </ol>
      </li>
      <li>2. ルクレは、前項各号のいずれかに該当する行為または該当するおそれのある行為が確認された場合、状況を判断した上で情報の変更、登録削除を含めたしかるべき処置をとります。なお、削除結果に関する質問・苦情は一切受け付けておりません。また、禁止行為に基づきルクレまたは第三者が損害を被った場合は、当該ユーザがこれを賠償するものとします。</li>
    </ol>
    <br />
    <br />
    <h2>第10条 （ユーザ資格の停止・取消）</h2>
    <ol>
      <li>
        1. ルクレは、ユーザが次の各号のいずれかに該当する場合、当該ユーザのユーザ資格を事前に通知することなく、一時停止または取り消すことができ、当該ユーザのために保管するコンテンツを返還する義務を負わないものとします。また、ユーザが次の各号のいずれかに該当することによりルクレまたは第三者が損害を被った場合には、当該ユーザはルクレまたは第三者が被った損害を賠償するものとします。
        <ol>
          <li>(1) 本規約のいずれかの条項に違反した場合</li>
          <li>(2)  ユーザに対する破産の申し立てがあった場合、またはユーザ自らが破産の申し立てをした場合</li>
          <li>(3) ユーザが後見開始、補佐開始、または補助開始の審判を受けた場合</li>
          <li>(4) その他ルクレがユーザとして不適当と判断した場合</li>
        </ol>
      </li>
    </ol>
    <br />
    <br />
    <h2>第11条 （準拠法）</h2>
    <p>本規約に関する準拠法は、日本法とします。</p>
    <br />
    <br />
    <h2>第12条 （合意管轄）</h2>
    <p>ユーザとルクレとの間で訴訟の必要が生じた場合には、東京地方裁判所をユーザとルクレの第一審の専属的合意管轄裁判所とします。</p>
    <br />
    <br />
    <p>2020年3月18日制定</p>
    <br />
    <br />
    <p>東京都港区北青山1‐2‐3 青山ビル3F</p>
    <p>株式会社ルクレ</p>
  </div>
</template>

<script>
export default {
  name: 'TermsOfService'
}
</script>

<style scoped>
.wrap {
  padding: 2rem 5rem;
}
ol {
  list-style: none;
  padding-inline-start: 0.5rem;
}
</style>